import { createContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const { t, i18n } = useTranslation();
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
    const timer = setTimeout(() => {
      // Prefer URL query param (lng or lang) to allow SEO alternate links
      try {
        const url = new URL(window.location.href);
        const paramLng = url.searchParams.get('lng') || url.searchParams.get('lang');
        const supported = ['en','se','dk','no','fi','is'];
        if (paramLng && supported.includes(paramLng)) {
          i18n.changeLanguage(paramLng);
          try { localStorage.setItem('i18nextLng', paramLng); } catch (e) { void e; }
          return;
        }
      } catch { /* noop */ }

      const savedLanguage = localStorage.getItem('i18nextLng');
      if (savedLanguage && savedLanguage !== 'en' && savedLanguage !== 'undefined') {
        i18n.changeLanguage(savedLanguage);
        return;
      }
      const browserLang = navigator.language || (navigator.languages && navigator.languages[0]);
      if (browserLang) {
        const langMap = {
          'sv': 'se',
          'sv-SE': 'se',
          'da': 'dk',
          'da-DK': 'dk',
          'no': 'no',
          'nb': 'no',
          'nb-NO': 'no',
          'nn': 'no',
          'nn-NO': 'no',
          'fi': 'fi',
          'fi-FI': 'fi',
          'is': 'is',
          'is-IS': 'is',
          'en': 'en',
          'en-US': 'en',
          'en-GB': 'en',
        };
        const detectedLang = langMap[browserLang] || langMap[browserLang.split('-')[0]];
        if (detectedLang) {
          i18n.changeLanguage(detectedLang);
          localStorage.setItem('i18nextLng', detectedLang);
        }
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [i18n]);

  return (
    <I18nContext.Provider value={{ t, i18n, isHydrated }}>
      {children}
    </I18nContext.Provider>
  );
}

 
